import { Autocomplete, TextField } from "@mui/material";
import React from "react";

export interface SelectOption {
  value: any;
  label: string;
}

interface SelectSearchInputProps {
  field: string;
  value: any;
  onChange: (value: any) => void;
  placeholder?: string;
  options: SelectOption[];
}

export const SelectSearchInput: React.FC<SelectSearchInputProps> = ({
  field,
  value,
  onChange,
  placeholder,
  options,
}) => {
  const label = placeholder || field;
  const selectedOption =
    value === null || value === undefined
      ? null
      : options.find((option) => option.value === value) ?? null;

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={options}
      value={selectedOption}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      onChange={(_event, option) => onChange(option?.value ?? null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="All"
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: true,
          }}
        />
      )}
      sx={{
        "& .MuiInputBase-root": {
          fontSize: "0.8125rem",
          py: 0,
        },
        "& .MuiInputBase-input": {
          py: "6px !important",
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.75rem",
          fontWeight: 600,
        },
      }}
    />
  );
};
